var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 20.394A10 10 0 1 1 10 .395a10 10 0 0 1 0 19.999Zm0-18.571a8.571 8.571 0 1 0 0 17.142 8.571 8.571 0 0 0 0-17.142Zm4.071 10.114a.714.714 0 0 0-1.014 0l-2.343 2.414V7.537a.714.714 0 0 0-1.428 0v6.814l-2.343-2.4a.718.718 0 0 0-1.029 1l3.572 3.657a.714.714 0 0 0 1.028 0l3.572-3.657a.714.714 0 0 0-.015-1.014ZM10 6.108a.714.714 0 0 0 .714-.714V4.68a.715.715 0 0 0-1.428 0v.714a.714.714 0 0 0 .714.714Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.5d0db41e5fdffaea1ee3dd54092deb4f.svg";
export { ForwardRef as ReactComponent };